<aionz-purchase-request-activity-panel
  [purchaseId]="data().id"
  [panelTitle]="'Atividade da solicitação'"
  [panelSubtitle]="'#' + data().id">
  <div class="quotation-map-header">
    <div class="quotation-map-header-top">
      <div>
        <div class="quotation-map-title-row">
          <button
            mat-icon-button
            type="button"
            aria-label="Voltar para o quadro"
            class="back-button"
            (click)="handleGoBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>

          @if (loadState() === 'loading') {
            <aionz-quotation-map-header-skeleton section="title" />
          } @else {
            <span class="quotation-map-title">{{ data().title }}</span>
            <button
              mat-icon-button
              type="button"
              class="activity-icon-button"
              aionzTooltip="Atividade da solicitação"
              mode="message"
              aria-label="Abrir a atividade da solicitação"
              (click)="openActivityTab()">
              <mat-icon aria-hidden="true">timeline</mat-icon>
            </button>
            @if (quotationMapBoard(); as board) {
              @if (board.draftState() !== 'idle') {
                <span
                  class="draft-status"
                  [class.draft-status--error]="board.draftState() === 'error'"
                  role="status"
                  aria-live="polite">
                  @switch (board.draftState()) {
                    @case ('saving') {
                      Salvando rascunho…
                    }
                    @case ('saved') {
                      Rascunho salvo às {{ board.draftSavedAt() | date: 'HH:mm' }}
                    }
                    @case ('error') {
                      Não foi possível salvar o rascunho. Suas escolhas continuam nesta tela.
                    }
                  }
                </span>
              }
            }
          }
        </div>

        <div class="quotation-map-meta">
          @if (loadState() === 'loading') {
            <aionz-quotation-map-meta-skeleton />
          } @else {
            <mat-basic-chip class="custom-chip custom-id-chip">#{{ data().id }}</mat-basic-chip>
            <aionz-purchase-request-status [status]="data().status"></aionz-purchase-request-status>

            <div class="requested-at">
              <mat-icon
                svgIcon="calendar_month"
                class="requested-at-icon" />
              <span class="requested-at-label">Solicitado em:</span>
              <span class="requested-at-value">{{ data().requestedAt | date: 'dd/MM/yy' }}</span>
            </div>
            @if (deliveryBranchesSummary().branches.length > 0) {
              @let multipleBranches = deliveryBranchesSummary().branches.length > 1;
              <!-- Para onde vão os itens: a quantidade de locais de um olhar; os nomes no tooltip.
                   Com mais de um, o clique agrupa os itens por local no mapa. -->
              <button
                type="button"
                class="custom-chip comments-chip branches-chip"
                [class.branches-chip--static]="!multipleBranches"
                [aionzTooltipComponent]="branchesTooltipComponent"
                [aionzTooltipData]="deliveryBranchesSummary()"
                aionzTooltipPosition="below"
                aionzTooltipClass="branches-tooltip"
                mode="message"
                [attr.aria-label]="deliveryBranchesLabel() + (multipleBranches ? '. Agrupar os itens por local de entrega' : '')"
                (click)="multipleBranches && quotationMapBoard()?.sortItemsByBranch()">
                <mat-icon aria-hidden="true">business</mat-icon>
                {{ deliveryBranchesLabel() }}
              </button>
            }
            @if (activityPanel().commentsCount() !== null) {
              @let commentsCount = activityPanel().commentsCount() ?? 0;
              @let comments =
                commentsCount === 0
                  ? 'Sem comentários'
                  : commentsCount === 1
                    ? '1 comentário'
                    : commentsCount + ' comentários';
              <button
                type="button"
                class="custom-chip comments-chip"
                [aionzTooltip]="commentsCount === 0 ? 'Escrever o primeiro comentário' : 'Abrir os comentários da solicitação'"
                mode="message"
                [attr.aria-label]="'Abrir os comentários da solicitação, ' + comments"
                (click)="openCommentsTab()">
                <mat-icon aria-hidden="true">forum</mat-icon>
                {{ comments }}
              </button>
            }
          }
        </div>
      </div>

      @if (loadState() === 'loading') {
        <aionz-quotation-map-header-skeleton section="actions" />
      } @else if (quotationMapBoard(); as board) {
        <div class="quotation-map-header-right">
          <div class="quotation-map-actions-main">
            <div class="quotation-map-total-block">
              <span class="quotation-map-total-label">Total negociado das seleções:</span>
              <strong class="quotation-map-total-value">
                {{ board.totalValue() | currency: 'BRL' : 'symbol' : '1.2-2' }}
              </strong>
              <mat-basic-chip
                class="saving-chip"
                aionzTooltip="Diferença entre o preço inicial cotado e o valor final negociado."
                mode="message">
                Economia obtida:
                <strong>{{ board.totalSaving() | currency: 'BRL' : 'symbol' : '1.2-2' }}</strong>
              </mat-basic-chip>
            </div>

            <div class="approve-block">
              <button
                matButton="filled"
                class="approve-btn"
                [disabled]="selectedTabIndex() !== 0"
                (click)="board.openAproveDialog()">
                Aprovar cotação
              </button>
              <span
                class="approve-progress"
                [class.approve-progress--none]="board.selectedItemsCount() === 0"
                [class.approve-progress--complete]="board.selectedItemsCount() === board.itemsCount()"
                aria-live="polite">
                {{ board.selectedItemsCount() }} de {{ board.itemsCount() }} itens selecionados
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  @if (quotationMapBoard(); as board) {
    @if (board.expiredSelectedSuppliers().length > 0) {
      <div
        class="expired-banner"
        role="alert">
        <mat-icon aria-hidden="true">event_busy</mat-icon>
        <span>
          Itens selecionados de
          <strong>{{ board.expiredSelectedSuppliers().join(', ') }}</strong>
          têm cotação vencida. Confirme os preços com o fornecedor antes de aprovar.
        </span>
      </div>
    }
  }
  <div class="quotation-map-tabs-container">
    @if (loadState() === 'loading') {
      <aionz-quotation-map-header-skeleton section="bestPriceToggle" />
    } @else if (quotationMapBoard(); as board) {
      <div class="quotation-map-board-tools">
        @if (board.hasHiddenSuppliers()) {
          <button
            matButton="outlined"
            type="button"
            class="collapse-suppliers-btn"
            aionzTooltip="Mostra de novo todas as colunas de fornecedor recolhidas"
            mode="message"
            (click)="board.expandAllSuppliers()">
            <mat-icon aria-hidden="true">visibility</mat-icon>
            Mostrar todas
          </button>
        } @else {
          <button
            matButton="outlined"
            type="button"
            class="collapse-suppliers-btn"
            aionzTooltip="Recolhe as colunas dos fornecedores sem nenhum item selecionado, para comparar só o que você escolheu"
            mode="message"
            [disabled]="selectedTabIndex() !== 0 || !board.canCollapseUnselected()"
            (click)="board.collapseSuppliersWithoutSelection()">
            <mat-icon aria-hidden="true">visibility_off</mat-icon>
            Recolher sem seleção
          </button>
        }

        <span
          class="board-tools-divider"
          aria-hidden="true"></span>

        <mat-button-toggle-group
          class="supplier-sort"
          hideSingleSelectionIndicator
          aria-label="Ordenar fornecedores"
          [value]="board.supplierSort()"
          [disabled]="selectedTabIndex() !== 0"
          (change)="board.setSupplierSort($event.value)">
          <mat-button-toggle
            value="default"
            aionzTooltip="Ordem em que os fornecedores entraram na cotação"
            mode="message">
            Ordem original
          </mat-button-toggle>
          <mat-button-toggle
            value="total"
            aionzTooltip="Do menor para o maior total cotado: preço × quantidade de todos os itens que o fornecedor respondeu"
            mode="message">
            Menor total
          </mat-button-toggle>
          <mat-button-toggle
            value="bestPrices"
            aionzTooltip="Fornecedores com mais itens no melhor preço primeiro"
            mode="message">
            Mais melhores preços
          </mat-button-toggle>
        </mat-button-toggle-group>

        <span
          class="board-tools-divider"
          aria-hidden="true"></span>

        <mat-checkbox
          color="primary"
          class="best-price-toggle"
          [disabled]="selectedTabIndex() !== 0"
          [checked]="board.allSelected()"
          [indeterminate]="board.someSelected()"
          (change)="board.toggleAll($event)">
          <span
            class="best-price-toggle-content"
            aionzTooltip="Selecionar, em cada item, o melhor preço apontado pela Cotação Inteligente do eBarn Cotai"
            mode="message">
            <mat-icon
              class="earnings-icon"
              svgIcon="earnings" />
            Melhores preços (Cotai)
          </span>
        </mat-checkbox>
      </div>
    }
    <mat-tab-group
      [mat-stretch-tabs]="false"
      [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="onTabChange($event)">
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex-row items-center gap-8">
            <mat-icon>dashboard</mat-icon>
            <span>Quadro</span>
          </div>
        </ng-template>

        @switch (loadState()) {
          @case ('loading') {
            <aionz-quotation-map-board-skeleton class="mt-3" />
          }
          @default {
            @if (data().items && data().items.length > 0) {
              <div class="quotation-map-board-wrapper mt-3">
                <aionz-quotation-map-board
                  [data]="quotationMapBoardData()"
                  [supplierSearchLoading]="isSearchingSuppliers()"
                  [supplierSearchProgress]="supplierSearchProgress()"
                  [lastSupplierSearchAt]="data().lastSupplierSuggestionSearchAt"
                  (onSearchSuppliers)="handleTriggerSupplierSuggestionSearch()"
                  (onApprove)="onApprove($event)"
                  (onSendRequestEmail)="onSendRequestEmail($event)"
                  (onCreateSupplier)="onCreateSupplier($event)"
                  (onDeleteSupplier)="onDeleteSupplier($event)"
                  (onAddSupplierToProduct)="onAddSupplierToProduct($event)"
                  (onUpdateSuggestedSupplierStatus)="onUpdateSuggestedSupplierStatus($event)" />
              </div>
            } @else {
              <div class="flex-col gap-4 p-16">
                <span class="normal-text">Nenhum item encontrado.</span>
                <span class="normal-text">Adicione itens para iniciar o processo de cotação.</span>
              </div>
            }
          }
        }
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex-row items-center gap-8">
            <mat-icon>attach_file</mat-icon>
            <span>Anexos</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <aionz-purchase-request-attachments
            [purchaseId]="data().id"></aionz-purchase-request-attachments>
        </ng-template>
      </mat-tab>
    </mat-tab-group>

  </div>
</aionz-purchase-request-activity-panel>
